<template>
    <section class="bg--white m-0 position-relative no-padding">
        <div class="container-fluid">
            <div class="row">
                <div class="main col-12">
                    <validation-observer ref="form">
                        <form action="" class="row">
                            <div class="form-section w-100">
                                <h2 class="heading-spacing--large pb-2">
                                    School
                                </h2>
                                <div class="row">
                                    <text-input
                                        v-model="profileUpdate.School.Name"
                                        class="col-12 col-md-6"
                                        name="Naam van school"
                                        :readonly="true"
                                    />
                                    <text-input
                                        v-model="profileUpdate.School.BRIN"
                                        class="col-12 col-md-6"
                                        name="BRIN"
                                        :readonly="true"
                                    />
                                    <text-input
                                        v-model="
                                            profileUpdate.School.LocationNumber
                                        "
                                        class="col-12 col-md-6"
                                        name="Vestigingsnummer"
                                        :readonly="true"
                                    />
                                </div>
                            </div>

                            <div class="form-section w-100">
                                <div class="form-section">
                                    <h2 class="heading-spacing--large pb-2">
                                        Adresgegevens school
                                    </h2>
                                    <div class="row">
                                        <text-input
                                            v-model="
                                                profileUpdate.School.Street
                                            "
                                            class="col-12 col-md-5"
                                            name="Straatnaam"
                                            :readonly="true"
                                        />
                                        <text-input
                                            v-model="
                                                profileUpdate.School.Housenumber
                                            "
                                            class="col-6 col-md-2"
                                            name="Huisnummer"
                                            type="number"
                                            :readonly="true"
                                        />
                                        <text-input
                                            v-model="
                                                profileUpdate.School
                                                    .HousenumberAddition
                                            "
                                            class="col-6 col-md-2"
                                            name="Toevoeging"
                                            :readonly="true"
                                        />
                                        <text-input
                                            v-model="
                                                profileUpdate.School.Zipcode
                                            "
                                            class="col-12 col-md-5"
                                            name="Postcode"
                                            :readonly="true"
                                        />
                                        <text-input
                                            v-model="profileUpdate.School.City"
                                            class="col-12 col-md-5"
                                            name="Plaats"
                                            :readonly="true"
                                        />
                                    </div>
                                </div>

                                <div class="form-section">
                                    <h2 class="heading-spacing--large pb-2">
                                        Persoongegevens
                                    </h2>
                                    <div class="row">
                                        <text-input
                                            v-model="profileUpdate.Firstname"
                                            class="col-12 col-md-5"
                                            name="Voornaam"
                                            @input="updateTeacherInformation"
                                        />
                                        <text-input
                                            v-model="profileUpdate.Insertion"
                                            class="col-6 col-md-2"
                                            name="Tussenvoegsel"
                                            @input="updateTeacherInformation"
                                        />
                                        <text-input
                                            v-model="profileUpdate.Lastname"
                                            class="col-6 col-md-5"
                                            name="Achternaam"
                                            @input="updateTeacherInformation"
                                        />
                                    </div>
                                </div>

                                <editPassword
                                    :profile="profileUpdate"
                                    class="col-12 col-md-12 login-small"
                                    @input="updateTeacherInformation"
                                />
                                <dashboardMessage
                                    :message="responseMsg"
                                    :process="processing"
                                />
                            </div>
                        </form>
                    </validation-observer>
                </div>
            </div>
        </div>
        <error-bar v-if="errorMessage" :error-message="errorMessage" />
    </section>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import { initVeeValidate } from '@/plugins/vee-validate';
import textInput from '@/components/form/text-input';
import editPassword from '@/components/form/edit-password';
import errorBar from '@/components/clientdashboard/dashboard-profile/error-bar';
import dashboardMessage from '@/components/clientdashboard/dashboard-profile/clientdashboard-profile-message';
import Axios from 'axios';

initVeeValidate();

export default {
    components: {
        ValidationObserver,
        textInput,
        editPassword,
        errorBar,
        dashboardMessage
    },
    props: {
        profile: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            responseMsg: '',
            errorMessage: '',
            validationError: false,
            success: false,
            submitted: false,
            processing: false,
            profileUpdate: {
                Firstname: '',
                Insertion: '',
                Lastname: '',
                Email: '',
                Removed: false,
                Group: [],
                ReadOnly: true
            }
        };
    },
    created() {
        this.profileUpdate = this.profile;
    },
    methods: {
        updateTeacherInformation() {
            this.submitted = true;
            this.processing = true;
            this.responseMsg = '';

            this.$refs.form.validate().then(success => {
                if (success) {
                    Axios.post(
                        '/clientdashboard/teacher/update',
                        this.profileUpdate
                    )
                        .then(response => {
                            this.response = response;
                            this.submitted = false;
                            this.error = false;
                            this.responseMsg = response.data.successMsg;
                            this.profileUpdate.Password = null;
                            this.profileUpdate.PasswordRepeat = null;
                            return;
                        })
                        .catch(error => {
                            this.processing = false;
                            this.setErrorMessage(
                                error.response.data.ExceptionMessage
                            );
                        })
                        .finally(() => {
                            const self = this;
                            this.processing = false;
                            setTimeout(function() {
                                self.responseMsg = '';
                            }, 5000);
                        });
                } else {
                    this.processing = false;
                    this.setErrorMessage(
                        'Controleer uw invoer, mogelijk zijn er verplichte velden niet ingevuld of zijn er velden niet correct ingevuld.'
                    );
                }
            });
        },
        setErrorMessage(message) {
            this.errorMessage = message;
            const self = this;
            setTimeout(function() {
                self.errorMessage = '';
            }, 5000);
        }
    }
};
</script>
